"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoTTypeToImmunity = void 0;
const enums_1 = require("../enums");
exports.DoTTypeToImmunity = {
    "Burning": enums_1.AttributeType.BurnDamageImmunity,
    "Bleeding": enums_1.AttributeType.BleedDamageImmunity,
    "Chill": enums_1.AttributeType.ChillDamageImmunity,
    "Poisoned": enums_1.AttributeType.PoisonDamageImmunity,
    "Curse": enums_1.AttributeType.CurseDamageImmunity,
};
